import storage from '../Storage';
import axios from 'axios';

import {AppConfig} from "../../ENV";

import {setUserData} from './UserDataSlice';


class UserDataService{
  
  setUserData(userData : {}){
    storage.dispatch(setUserData(userData));
    return userData;
  }
  
  async saveUserData(params: {}){
    const urlBase = `${AppConfig.user_simulator_tranking_api}/save-user-data/`;
    /* console.log(`###### Consultando API: ${urlBase} con parametros: `, params, '######') */
    axios.post(urlBase,params);
    return 'saving user data, redux service';
  }

  async sendBrevoUserData(data: {}){
    const urlBase = `${AppConfig.user_simulator_tranking_api}/brevo/trackEvent`;
    axios.post(urlBase, data);
    return 'sending brevo user data, redux service';
  }

}

export default new UserDataService();
